export default "/images/bf34a8b6e9181ff7acdcc4acbbd40b5f.avif";